import React, { useEffect, useState } from "react";
import { useFetch, useSave } from "../../components/Hooks/Conexao";
import { fetch, fetchLocalAgent } from "../../actions";
import { LabelPadrao, LoadingContainerPadrao } from "../../components/Base";
import VendaDetalhesPadrao from "./VendaDetalhesPadrao";
import ModalCancelamentoPadrao from "../../components/ModalCancelamentoPadrao";
import { connect } from "react-redux";
import Mensagens from "../../components/Mensagens";
import * as api from "./VendasApi";
import { BtnCancelar, BtnPadrao } from "../../components/Buttons";
import VendaDevolucaoModal from "./VendaDevolucaoModal";
import { Radio } from "antd";
import { imprimirRetorno } from "../../Utils/impressaoUtils";
import ErroModal from "../../components/ErroModal";
import DanfeViewer from "./NotaFiscal/DanfeViewer";
import ImpressaoVenda from "../Impressao/ImpressaoVenda";

function VendaDetalhe({ id, isLocal, enableEdit, ...props }) {
  const [venda, listar, loadingVenda] = useFetch(() => api.getById(props.fetch, id, isLocal));
  const [save, saving] = useSave();
  const [modalVisible, setModalVisible] = useState(null);
  const [modeloNF, setModeloNF] = useState(null);
  const [erroFinalizacao, setErroFinalizacao] = useState();
  const [dadosDanfe, setDadosDanfe] = useState(null);
  const [idVendaImpressao, setIdVendaImpressao] = useState(null);
  const [loadingImpressao, setLoadingImpressao] = useState(false);

  useEffect(() => {
    if (id)
      listar();

  }, [id]);

  useEffect(() => setModeloNF(venda?.isDevolucao ? "nfe" : "nfce"), [venda]);

  const cancelar = txt => save(() => api.deletar(props.fetch, { id: id, motivo: txt, isLocal }), () => { setModalVisible(null); Mensagens.showSucesso("Venda cancelada com sucesso!"); props.onOk(); }, { onRejected: err => setErroFinalizacao({ title: "Erro ao processar o cancelamento da venda", erros: [err] }) });
  const devolver = (prds, pagamentos, totaisDev, clienteId) => save(() => props.fetch().post("venda/devolver", { ...totaisDev, isLocal, id: venda.id, clienteId, prds, pagamentos, valorTotal: totaisDev.liquido, isLocal }), () => { setModalVisible(false); Mensagens.showSucesso("Venda devolvida com sucesso!"); props.onOk(); }, { onRejected: err => setErroFinalizacao({ title: "Erro ao processar a devolução", erros: [err] }) });
  const emitirNf = () => save(() => props.fetch().post("venda/emitir/nf", { id, isLocal, modeloNF }), () => { Mensagens.showSucesso("Nota fiscal emitida com sucesso!"); listar(); }, { onRejected: err => setErroFinalizacao({ title: "Erro ao processar a venda", erros: [err] }) });
  const imprimirNf = () => save(() => props.fetch().post(`venda/imprimir/${venda.id}`), ret => {

    if (ret.isDanfe)
      setDadosDanfe(ret);
    else if (!!ret.vendaId)
      setIdVendaImpressao(ret.vendaId);
    else
      imprimirRetorno(props.fetchLocalAgent, ret, setLoadingImpressao);
  });

  return <>
    <LoadingContainerPadrao loading={loadingVenda || saving || loadingImpressao} style={{ minHeight: 400 }} >
      <div style={{ ...props.style }}>
        {venda && <VendaDetalhesPadrao title="Venda" venda={venda} isLocal={isLocal} >
          {enableEdit && <>
            <BtnCancelar style={{ marginRight: 10 }} onClick={() => setModalVisible("can")} />
            {!venda.isDevolucao && <BtnPadrao style={{ marginRight: 10 }} onClick={() => setModalVisible("dev")}>Devolver itens</BtnPadrao>}
          </>}

          <BtnPadrao onClick={imprimirNf}>Imprimir</BtnPadrao>
          {(!venda.nf && props.hasCertificadoDigital) &&
            <BtnPadrao style={{ marginLeft: 10 }} onClick={emitirNf} showConfirm txtConfirm="Emitir a nota fiscal desta venda" showConfirmExtra={<div style={{ textAlign: "center", marginTop: 10 }}>
              <LabelPadrao noMargin>Forma de emissão</LabelPadrao>
              <Radio.Group value={modeloNF} onChange={v => setModeloNF(v.target.value)}>
                {!venda.isDevolucao && <Radio value="nfce">Cupom</Radio>}
                <Radio style={{ margin: 0 }} value="nfe">Danfe</Radio>
              </Radio.Group>
            </div>}>Emitir nota fiscal</BtnPadrao>}

        </VendaDetalhesPadrao>}
      </div>
    </LoadingContainerPadrao>
    <ModalCancelamentoPadrao visible={modalVisible == "can"} onOk={cancelar} onCancel={() => setModalVisible(null)} loading={saving} title="Motivo do cancelamento da Venda" />
    <VendaDevolucaoModal visible={modalVisible == "dev"} produtos={venda?.produtosDevolucao} pagamentos={venda?.pagamentosDev} pagamentosOriginais={venda?.pagamentos} onCancel={() => setModalVisible(null)} onOk={devolver} cliente={venda?.det?.cliente} loading={saving} showCliente />

    <DanfeViewer visible={!!dadosDanfe} empresaPk={dadosDanfe?.empresaPk} chave={dadosDanfe?.chaveNfe} onCancel={() => setDadosDanfe(null)} />
    <ImpressaoVenda id={idVendaImpressao} onCancel={() => setIdVendaImpressao(null)} />

    <ErroModal title={erroFinalizacao?.title} visible={!!erroFinalizacao} onCancel={() => setErroFinalizacao(null)} >
      {erroFinalizacao?.erros?.map(x => <p key={x?.toString()} style={{ marginTop: 20, textAlign: "center" }}>{x?.toString()}</p>)}
    </ErroModal>
  </>;
}

const mapStateToProps = state => ({ hasCertificadoDigital: state.dados.hasCertificadoDigital });

export default connect(mapStateToProps, { fetch, fetchLocalAgent })(VendaDetalhe);
